module.exports = __webpack_public_path__ + "img/SHProductType.d1ec1539.svg";